var scope_0 = require('/Users/zhannum/git/the-dark-between/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4167675181911ad32367e12838a71f4f.js').default;
var scope_1 = require('/Users/zhannum/git/the-dark-between/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/501e158cc5df1f82d79c83aa117d97fa.js').default;
var scope_2 = require('/Users/zhannum/git/the-dark-between/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb19e6af1649f34817629ba2a2cad7bc.js').default;
var scope_3 = require('/Users/zhannum/git/the-dark-between/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_4 = require('/Users/zhannum/git/the-dark-between/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fcdcf01cd0a1fabafbbd851d4fd163fb.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    